import { Map } from "immutable";
import { createSelector } from "reselect";

export const getAllCountries = (state) => state.countriesAndStates.all_countries;
const getAllStates = (state) => state.countriesAndStates.states;
const getAllEUCountries = (state) => state.countriesAndStates.eu_countries;
const defaultStatesByCountry = Map();
const getStatesByCountryKey = (state, key = ``) => {
  return getAllStates(state).get(`${key}`.toLowerCase(), defaultStatesByCountry);
};
const getEUCountryByKey = (state, key = ``) => getAllEUCountries(state).get(`${key}`);

export const makeCountriesAsSelectOptionsSelector = () => {
  return createSelector(getAllCountries, (countries) => {
    return countries
      .sortBy((country) => country)
      .map((countryName, countryCode) => ({
        id: countryCode,
        name: countryName,
      }))
      .toArray();
  });
};

export const makeStatesByCountryAsSelectOptionsSelector = () => {
  return createSelector(
    (state, country) => getStatesByCountryKey(state, country),
    (states) => {
      return states
        .sortBy((state) => state)
        .map((stateName, stateCode) => ({
          id: stateCode,
          name: `${stateCode} - ${stateName}`,
        }))
        .toArray();
    }
  );
};

export const makeIsEUCountryByKeySelector = () => {
  return createSelector(getEUCountryByKey, (country) => !!country);
};
